export const en = {
  nav: {
    about:     "About me",
    projects:  "My projects",
    education: "Education",
    contact:   "Contact",
  },

  hero: {
    title:       "Master's Student in Software Architecture & Computer Engineering",
    subtitle:    "Come discover who I am through this portfolio 🌱",
    cv:          "View my resume",
    cvDownload:  "Download my resume",
    cvViewer:    "PDF Resume Viewer",
    github:      "GitHub",
    contact:     "Contact me",
  },

  about: {
    title:   "About me !",
    iam:     "I am:",
    bio:     "A 23-year-old code pirate 🏴‍☠️, sailing the seas of programming with passion and drive, in search of the treasure of knowledge ⛵.",
    quote:   "\"The fruit of our failures is the compost of our success\" - 2019",
    author:  "Ziadi Noé 🍂",
    linkedin: "Find me on LinkedIn →",
    texts: [
      "Full Stack Developer 💻",
      "Apprentice at Moovijob 😍",
      "Former apprentice at CHAUSSEA 👟",
      "Future A.I. Engineer 🤖",
      "Probably sleeping 😴",
      "Error 404 [Human not found]",
      "Better than you at PixelWar 🖼️",
    ],
  },

  projects: {
    title:       "My projects !",
    learnMore:   "Learn more →",
    unavailable: "⛔ Unavailable",
  },

  education: {
    title: "Education !",
  },

  skills: {
    title: "Technical skills !",
  },

  footer: {
    rights: "All rights reserved.",
  },
};
